export default __webpack_public_path__ + "files/bde7b9641213b429d012fd8a4c3d8766.png";